// src/plugins/api.js
export default {
  install(app, store) {
    let isRefreshing = false;
    let refreshQueue = [];

    const processQueue = (token) => {
      refreshQueue.forEach(p => p.resolve(token));
      refreshQueue = [];
    };



    const api = async (url, options = {}) => {
      let token = store.state.atoken || "";
// console.log('token in api', token)
      options.headers = {
        ...options.headers,
        Authorization: "Bearer " + token,
        "Content-Type": "application/json"
      };

      let res = await fetch(store.state.server + url, options);

      if (res.status === 401) {
        // Всегда обновляем токен через refresh
        const refreshToken = store.state.rtoken;
        if (!refreshToken) {
          store.dispatch("logout");
          // alert("Сессия истекла");
          window.location.href = "/login";
          return;
        }

        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            refreshQueue.push({
              resolve: (newToken) => {
                options.headers["Authorization"] = "Bearer " + newToken;
                resolve(fetch(url, options).then(r => r.json()));
              },
              reject
            });
          });
        }

        isRefreshing = true;
          // console.log(JSON.stringify({ refreshToken }))
        try {
          const refreshRes = await fetch(store.state.server + "/api/login/refresh", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refreshToken })
          });

             if(!refreshRes.ok){
                    throw new Error("refresh failed")
                }
          //  console.log('refreshData',refreshData)
          //       console.log('refreshRes',refreshRes.json())
          const refreshData = await refreshRes.json();

  console.log('token after refresh',refreshData)
        
            store.state.atoken=refreshData.AToken
            store.state.rtoken= refreshData.RToken || refreshToken
         

          token = store.state.atoken;

        
          processQueue(token);

          options.headers["Authorization"] = "Bearer " + token;
          return fetch(store.state.server + url, options).then(r => r.json());

        }
        catch (err) {

  //  processQueue(err)
refreshQueue = [];
   store.dispatch("logout")
  //  window.location.href="/"

        } 
        finally {
          isRefreshing = false;
        }

      } else {
        return res.json();
      }
    };

    app.config.globalProperties.$api = api;
  }
};